import React, { useState } from 'react';

const SearchBox = () => {
    const [searchData, setSearchData] = useState({
        division: '',
        date: '',
        guest: '1'
    });

    const handleChange = (e) => {
        setSearchData({
            ...searchData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Search data:', searchData);
        // Add your search logic here
    };

    // Generate date options for the next year
    const getMinDate = () => {
        return new Date().toISOString().split('T')[0];
    };

    const getMaxDate = () => {
        const nextYear = new Date();
        nextYear.setFullYear(nextYear.getFullYear() + 1);
        return nextYear.toISOString().split('T')[0];
    };

    return (
        <div
            className="search-box"
            style={{
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                padding: '20px 25px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                border: '1px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(10px)',
                maxWidth: '900px',
                margin: '0 auto'
            }}
        >
            <form
                onSubmit={handleSubmit}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    flexWrap: 'nowrap'
                }}
            >
                {/* Destination Field */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: '1',
                    minWidth: '180px'
                }}>
                    <label
                        htmlFor="select-division"
                        style={{
                            color: '#2d3748',
                            fontSize: '12px',
                            fontWeight: '600',
                            marginBottom: '6px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                    >
                        Destinations
                    </label>
                    <select
                        id="select-division"
                        name="division"
                        value={searchData.division}
                        onChange={handleChange}
                        required
                        style={{
                            width: '100%',
                            padding: '12px 15px',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            fontSize: '14px',
                            backgroundColor: '#fff',
                            outline: 'none',
                            transition: 'all 0.3s ease',
                            color: '#4a5568',
                            fontWeight: '500',
                            cursor: 'pointer',
                            height: '44px'
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#f7921f';
                            e.target.style.boxShadow = '0 0 0 2px rgba(247, 146, 31, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#e2e8f0';
                            e.target.style.boxShadow = 'none';
                        }}
                    >
                        <option value="" disabled style={{ color: '#a0aec0' }}>Select Division</option>
                        <option value="Barishal">Barishal</option>
                        <option value="Chattogram">Chattogram</option>
                        <option value="Dhaka">Dhaka</option>
                        <option value="Khulna">Khulna</option>
                        <option value="Mymensingh">Mymensingh</option>
                        <option value="Rajshahi">Rajshahi</option>
                        <option value="Rangpur">Rangpur</option>
                        <option value="Sylhet">Sylhet</option>
                    </select>
                </div>

                {/* Date Field */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: '1',
                    minWidth: '150px'
                }}>
                    <label
                        htmlFor="search-date"
                        style={{
                            color: '#2d3748',
                            fontSize: '12px',
                            fontWeight: '600',
                            marginBottom: '6px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                    >
                        Date
                    </label>
                    <input
                        type="date"
                        id="search-date"
                        name="date"
                        value={searchData.date}
                        onChange={handleChange}
                        min={getMinDate()}
                        max={getMaxDate()}
                        style={{
                            width: '100%',
                            padding: '12px 15px',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            fontSize: '14px',
                            backgroundColor: '#fff',
                            outline: 'none',
                            transition: 'all 0.3s ease',
                            color: '#4a5568',
                            fontWeight: '500',
                            cursor: 'pointer',
                            height: '44px'
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#f7921f';
                            e.target.style.boxShadow = '0 0 0 2px rgba(247, 146, 31, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#e2e8f0';
                            e.target.style.boxShadow = 'none';
                        }}
                    />
                </div>

                {/* Guest Field */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: '1',
                    minWidth: '130px'
                }}>
                    <label
                        htmlFor="guest-dropdown"
                        style={{
                            color: '#2d3748',
                            fontSize: '12px',
                            fontWeight: '600',
                            marginBottom: '6px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                    >
                        Guest
                    </label>
                    <select
                        id="guest-dropdown"
                        name="guest"
                        value={searchData.guest}
                        onChange={handleChange}
                        style={{
                            width: '100%',
                            padding: '12px 15px',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            fontSize: '14px',
                            backgroundColor: '#fff',
                            outline: 'none',
                            transition: 'all 0.3s ease',
                            color: '#4a5568',
                            fontWeight: '500',
                            cursor: 'pointer',
                            height: '44px'
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#f7921f';
                            e.target.style.boxShadow = '0 0 0 2px rgba(247, 146, 31, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#e2e8f0';
                            e.target.style.boxShadow = 'none';
                        }}
                    >
                        <option value="1">1 Guest</option>
                        <option value="2">2 Guests</option>
                        <option value="3">3 Guests</option>
                        <option value="4">4 Guests</option>
                        <option value="5">5 Guests</option>
                        <option value="6">6+ Guests</option>
                    </select>
                </div>

                {/* Submit Button */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: '120px'
                }}>
                    <button
                        type="submit"
                        style={{
                            width: '100%',
                            padding: '12px 20px',
                            backgroundColor: '#f7921f',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            height: '44px',
                            marginTop: '20px'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#e6831a';
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 4px 12px rgba(247, 146, 31, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#f7921f';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = 'none';
                        }}
                    >
                        Search
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SearchBox;